//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import DefaultModal from '@components/DefaultModal';
import { DangerButtonStyles } from '@components/atoms/button/buttonStyles';
import { BodyText } from '@components/atoms/text/Text';
import makeAngularReactControllerWithScope from '@react-bridge/angular-react-widget-with-scope';
import { pluralize } from '@utils/stringUtils';

import { ISelectedItem } from 'app/bulk-actions/model/ISelectedItem';
import { UiaBulkActionsTrackingIds } from 'app/bulk-actions/uia-bulk-actions/uiaBulkActionsTrackingIds';

interface DeleteFromLibraryConfirmationModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onComplete: () => void;
  permissionName?: string;
  selectedItems: ISelectedItem[];
}

export const DeleteFromLibraryConfirmationModal = ({
  isOpen,
  onCancel,
  onComplete,
  permissionName,
  selectedItems,
}: DeleteFromLibraryConfirmationModalProps) => {
  return (
    <DefaultModal
      closeModal={onCancel}
      contents={
        <BodyText>
          Delete {pluralize(selectedItems.length, 'item')} from your library?
        </BodyText>
      }
      isModalOpen={isOpen}
      primaryButtonInfo={{
        buttonContent: 'Delete',
        buttonStyles: DangerButtonStyles,
        onClick: onComplete,
        permissionName,
        trackingId: UiaBulkActionsTrackingIds.DELETE_FROM_LIBRARY_CONFIRMATION,
      }}
      secondaryButtonInfo={{
        buttonContent: 'Cancel',
        onClick: onCancel,
        trackingId: UiaBulkActionsTrackingIds.CANCEL_DELETE_FROM_LIBRARY,
      }}
      title='Delete Media'
    />
  );
};

angular.module('curalate').component('deleteFromLibraryConfirmationModal', {
  bindings: {
    isOpen: '@',
    onCancel: '&',
    onComplete: '&',
    permissionName: '@',
    selectedItems: '<',
  },
  controller: makeAngularReactControllerWithScope(
    ({ $ctrl }: { $ctrl: DeleteFromLibraryConfirmationModalProps }) => {
      return <DeleteFromLibraryConfirmationModal {...$ctrl} />;
    },
  ),
});
